<template>
  <div ref="brandNameTagChartNet2"></div>
</template>

<script>
import * as d3 from "d3";
import debounce from "lodash";

export default {
  name: "BrandNameTagChartNet2",
  data() {
    return {
      nodes: [
      ],
      links: [
      ],
      initWidth: 600,
      debouncedResize: null,
      resizeObserver: null
    };
  },
  props: {
    netChartNodes: {
      type: Array,
      default: () => [],
    },
    netChartLinks: {
      type: Array,
      default: () => [],
    },
    whichChart: {
      type: String,
      default: '',
    },
  },
  watch: {
    netChartNodes() {
      this.updateGraph();
    },
    whichChart() {
      this.unSelectNode();
    },
  },
  created() {
    this.debouncedResize = _.debounce(this.handleResize, 200)
  },
  mounted() {
    this.createGraph();

    window.addEventListener('resize', this.debouncedResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.debouncedResize);
  },
  methods: {
    handleResize(event) {
      this.updateGraph();
    },

    unSelectNode(){
      console.log('-- unSelectNode --')
      const svg = d3
        .select(this.$refs.brandNameTagChartNet2)
      svg.selectAll('.selected')
        .classed('selected', false)
        .style('stroke', '#1951DC')
        .style('stroke-width', '0');
    },

    nodeClicked(event, d) {
      console.log('-- nodeClicked --')
      console.log(event.target.tagName)
      console.log(event.target)

      if(event.target.tagName == 'rect'){
        this.$parent.changeNode(event.target.__data__.id)
      }else if(event.target.tagName == 'text'){
        if(event.target.style.fontSize == '20px'){
          this.$parent.changeNode('0000')
        }else{
          this.$parent.changeNode(event.target.innerHTML)
        }
      }else{
        this.$parent.changeNode('0000')
      }
    },

    updateGraph() {      
      console.log('netChart updateGraph!!!');

      let pre_svg = d3
        .select(this.$refs.brandNameTagChartNet2)
      pre_svg.selectAll("*").remove();

      // var width = this.$refs.brandNameTagChartNet2.offsetWidth;
      var width = document.getElementById('chartCol').offsetWidth - 40


      if(width == 0){
        width = this.initWidth
      }else{
        this.initWidth = width
      }

      const height = 600;

      const svg = d3
        .select(this.$refs.brandNameTagChartNet2)
        .append("svg")
        .attr("width", width)
        .attr("height", height)
        .style("background-color", '#fff')
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
            })
            .on("drag", (event, d) => {
            })
            .on("end", (event, d) => {
              svg.selectAll('.selected')
                .classed('selected', false)
                .style('stroke', '#1951DC')
                .style('stroke-width', '0');
            })
        )
        .on("click", (event, d) => this.nodeClicked(event, d))
        ;

      const simulation = d3
        .forceSimulation(this.netChartNodes)
        .force(
          "link",
          d3.forceLink(this.netChartLinks).id((d) => d.id).distance(function(d){
            if(d.target.id === '상품명' || d.target.id === '라인 브랜드'){
              return 50
            }else{
              // 80~240 사이 랜덤 정수
              var _distance = Math.floor(Math.random() * (210 - 80 + 1)) + 100
              return _distance
            }
          })
        )
        .force("charge", d3.forceManyBody().strength(function(d){
          if((d.group === 1) || (d.group === 2)){
              return -400
            }else{
              return -600
            }
        }))

        .force("center", d3.forceCenter(width / 2, height / 2));

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.netChartLinks)
        .enter()
        .append("line")
        .attr("stroke-width", function(d){
          if (d.target.id.startsWith('sub_brand') || d.target.id.startsWith('product') || d.target.id.startsWith('person_ad') || d.target.id === "상품명" || d.target.id === "라인브랜드" || d.target.id === "광고/인물"){
            return 0
          }else{
            return 2
          }
        })
        .attr("stroke", "#aaa");

      const nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.netChartNodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", function(d){
          if (d.group ===1){
            return 10
          }else{
            return 50
          }
        })
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#FFFFFF"))
        .attr('stroke', function(d){
          return "#1951DC"
        })
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
              svg.selectAll('.selected')
                .classed('selected', false)
                .style('stroke', '#1951DC')
                .style('stroke-width', '0');
            })
        )
        // .on("click", (event, d) => this.nodeClicked(event, d))
        ;


      var sub_brand_rank = 0
      var product_rank = 0
      var person_ad_rank = 0

      const sub_brand_color = ['#ff7f0e', '#FF9F4A', '#FF9F4A', '#FFB777', '#FFB777', '#FFB777', '#FFC999', '#FFC999', '#FFC999', '#FFC999', '#FFD6B2', '#FFD6B2', '#FFD6B2', '#FFD6B2', '#FFD6B2']
      const product_color = ['#FF0000', '#FF7070', '#FF7070', '#FF9494', '#FF9494', '#FF9494', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFAFAF', '#FFD7D7', '#FFD7D7', '#FFD7D7', '#FFD7D7', '#FFD7D7']
      const person_ad_color = ['#008000', '#40A040', '#40A040', '#70B870', '#70B870', '#70B870', '#94CA94', '#94CA94', '#94CA94', '#94CA94', '#AFD7AF', '#AFD7AF', '#AFD7AF', '#AFD7AF', '#AFD7AF']
      
      
      //////////////////////////////////////////////////////////////////////////////////////////////////
      const nodeRectangles = svg
        .append("g")
        .selectAll("g") // 각 노드를 위한 그룹
        .data(this.netChartNodes)
        .enter()
        .append("g")
        .filter(d => d.group === 3) // 필요한 노드만
        .call(
          d3.drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;

              svg.selectAll('.selected')
                .classed('selected', false)
                .style('stroke', '#1951DC')
                .style('stroke-width', '0');
              
              d3.select(event.sourceEvent.target.parentNode)
                .classed('selected', true)
                .style('stroke', '#1951DC')
                .style('stroke-width', '3');

            })
        )
        // .on("click", (event, d) => this.nodeClicked(event, d))
        // .on('click', function(event, d){
        //   console.log('--- rect click ---')
        //   console.log('@@@@@@@@@@@@')
        //   console.log(this)
          
        //   console.log('@@@@@@@@@@@@')
        //   console.log(d)
        //   console.log(d.id)
        //   console.log('@@@@@@@@@@@@')
          
          
        //   // svg.selectAll('.selected')
        //   //   .classed('selected', false)
        //   //   .style('stroke', '#1951DC')
        //   //   .style('stroke-width', '0');
          
        //   // d3.select(this)
        //   //   .classed('selected', true)
        //   //   .style('stroke', '#1951DC')
        //   //   .style('stroke-width', '3')
        // })
        .on('mouseenter', function() {
            d3.select(this).raise()
        })
        ;
      
      
      nodeRectangles.append("rect")
        .attr("rx", 5)
        .attr("width", function(d){ 
          if(d.id.length < 3){
            return d.id.length*30
          }else if(d.id.length >= 3 && d.id.length <= 8){
            return d.id.length*17
          }else{
            return d.id.length*13
          }
          })
        .attr("height", function(d){ 
          return 30
          })
        .attr("fill", function(d){ 
          if(d.gubun === "nothing"){
            return "none"
          }else{
            return d.color
          }
          });

      nodeRectangles.append("text")
        .attr("x", function(d){
          if(d.id.length < 3){
            return d.id.length*30/2
          }else if(d.id.length >= 3 && d.id.length <= 8){
            return d.id.length*17/2
          }else{
            return d.id.length*13/2
          }
        })
        .attr("y", function(d){
          return (30/2 + 5)
        })
        .attr("text-anchor", "middle")
        .text((d) => (d.gubun === "nothing" ? "" : d.id))
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#414141"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .style("font-size", function(d){
          if(d.group == 2){
            return 20
          }else{
            return 13
          }
        })



      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.netChartNodes)
        .enter()
        .append("text")
        .attr("dy", (d) => (d.group === 2 ? 0 : 4))
        .attr("text-anchor", "middle")
        .text(function(d){
          if(d.group === 2){
            if(d.gubun === "nothing"){
              return ""
            }else{
              return d.id
            }
          }else{
            return ""
          }
        })
        .attr("fill", (d) => (d.group === 3 ? "#FFFFFF" : "#414141"))
        .attr("stroke", (d) => (d.group === 3 ? "none" : "#414141"))
        .attr("stroke-width", (d) => (d.group === 3 ? "none" : 0.5))
        .style("font-size", function(d){
          if(d.group == 2){
            return 20
          }else{
            if(d.rank == 1){
              return 25
            }else if(d.rank > 1 && d.rank < 4){
              return 20
            }else if(d.rank > 3 && d.rank < 7){
              return 17
            }else{
              return 15
            }
          }
        })
        ;

      
      
      
      //////////////////////////////////////////////////////////////////////////////////////////////////


      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);


        nodeRectangles.attr("transform", function(d){
          if(d.id.length < 3){
            var newX = (d.x-(d.id.length*30/2))
          }else if(d.id.length >= 3 && d.id.length <= 8){
            var newX = (d.x-(d.id.length*17/2))
          }else{
            var newX = (d.x-(d.id.length*13/2))
          }
          var newY = (d.y-15)
            return 'translate('+newX+', '+newY+')'
        });


        
        label.attr("x", (d) => d.x).attr("y", (d) => (d.y+5));
        
      });
    },
    createGraph() {
      console.log('createGraph!!!');
      
      const width = 600;
      const height = 600;

      const svg = d3
        .select(this.$refs.brandNameTagChartNet2)
        .append("svg")
        .attr("width", width)
        .attr("height", height);

      const simulation = d3
        .forceSimulation(this.nodes)
        .force(
          "link",
          d3.forceLink(this.links).id((d) => d.id).distance(50)
        )
        .force("charge", d3.forceManyBody().strength(-400))
        .force("center", d3.forceCenter(width / 2, height / 2));

      const link = svg
        .append("g")
        .selectAll("line")
        .data(this.links)
        .enter()
        .append("line")
        .attr("stroke-width", 0)
        .attr("stroke", "#aaa");

      const nodeCircles = svg
        .append("g")
        .selectAll("circle")
        .data(this.nodes)
        .enter()
        .filter(d => d.group != 3)
        .append("circle")
        .attr("r", 20)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "none"))
        .attr('stroke', (d) => (d.group === 1 ? "none" : "#ff7f0e"))
        .attr('stroke-width', (d) => (d.group === 1 ? "none" : 2))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      const nodeRectangles = svg
        .append("g")
        .selectAll("rect")
        .data(this.nodes)
        .enter()
        .filter(d => d.group === 3)
        .append("rect")
        .attr('width', 40)
        .attr('height', 40)
        .attr("fill", (d) => (d.group === 1 ? "#ff7f0e" : "#1f77b4"))
        .call(
          d3
            .drag()
            .on("start", (event, d) => {
              if (!event.active) simulation.alphaTarget(0.3).restart();
              d.fx = d.x;
              d.fy = d.y;
            })
            .on("drag", (event, d) => {
              d.fx = event.x;
              d.fy = event.y;
            })
            .on("end", (event, d) => {
              if (!event.active) simulation.alphaTarget(0);
              d.fx = null;
              d.fy = null;
            })
        );

      
      
      const label = svg
        .append("g")
        .selectAll("text")
        .data(this.nodes)
        .enter()
        .append("text")
        .attr("dy", 4)
        .attr("text-anchor", "middle")
        .text((d) => d.id);

      simulation.on("tick", () => {
        link
          .attr("x1", (d) => d.source.x)
          .attr("y1", (d) => d.source.y)
          .attr("x2", (d) => d.target.x)
          .attr("y2", (d) => d.target.y);

        nodeCircles.attr("cx", (d) => d.x).attr("cy", (d) => d.y);
        nodeRectangles.attr("x", (d) => d.x).attr("y", (d) => d.y).attr('transform', 'translate(-10, -7)');

        label.attr("x", (d) => d.x).attr("y", (d) => d.y);
      });
    },
  },

  mounted() {
    const targetEl = document.getElementById('chartCol')

    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries)
        this.debouncedResize();
    })

    this.resizeObserver.observe(targetEl)
  },

  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }

    if (this.debouncedResize && this.debouncedResize.cancel) {
      this.debouncedResize.cancel() // 대기 중인 debounce 호출 취소
    }
  }
};
</script>

<style scoped>
/* SVG 스타일링을 위해 CSS 추가 */
svg {
  background: #CFCFCF;
}



</style>
